import React from 'react'
import DetailedPage from '../../../../../component/common/landing-page/DetailedLandingPage'

export default function DetailedLandingPage() {

    return (
        <>
            <DetailedPage />
        </>
    )
}

